(function() {
    angular.module('tmx-app').factory('ProcessInstancesService', ['tmxResource', '$q',
        function(tmxResource, $q) {
            var ProcessInstances = tmxResource("ProcessInstance");
            ProcessInstances.getAllProcessInstances = function() {
                return ProcessInstances.all();
            };

            ProcessInstances.deleteById = function(id) {
                var deferred = $q.defer();
                ProcessInstances.getById(id).then(function(result) {
                    deferred.resolve(result.$remove());
                });
      // item.$remove();
                return deferred.promise;
            };
            ProcessInstances.recievedLov = true;
            ProcessInstances.status = [
                { HiddenValue: "Idled",
                    VisibleValue: "Idled"
                },
                { HiddenValue: "Finalized",
                    VisibleValue: "Finalized"
                }
            ];

            ProcessInstances.gridColumn = [
                {
                    field: "Id",
                    title: "Process ID",
                    type: "string",
                    template: "<md-button class='tmx-primary-text' ng-disabled='!ProcessInstancesCtrl.isStatusActive(dataItem)' ng-click='ProcessInstancesCtrl.clickEdit(dataItem)'>  #=Id# <md-tooltip md-direction='top'>#=Id#</md-tooltip>  </md-button>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : ProcessInstancesCtrl.isFiltered('Id')}\" >Process ID<i class='fa fa-filter' ng-if='ProcessInstancesCtrl.isFiltered(\"Id\")' ></i></span>"
                },  
                {
                    field: "StateName",
                    title: "Current State",
                    type: "string",
                    headerTemplate:"<span class=\"k-link\"  ng-class=\"{ 'filter-active' : ProcessInstancesCtrl.isFiltered('StateName')}\" >Current State<i class='fa fa-filter' ng-if='ProcessInstancesCtrl.isFiltered(\"StateName\")' ></i></span>"
                },
                {
                    field: "SchemeCode",
                    title: "Scheme Code",
                    type: "string",
        // sortable: false
                    headerTemplate:"<span class=\"k-link\"  ng-class=\"{ 'filter-active' : ProcessInstancesCtrl.isFiltered('SchemeCode')}\" >Scheme Code<i class='fa fa-filter' ng-if='ProcessInstancesCtrl.isFiltered(\"SchemeCode\")' ></i></span>"
                }, 
                {
                    field: "ProcessStatus",
                    title: "Status",
                    type: "select",
                    data: ProcessInstances.status,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : ProcessInstancesCtrl.isFiltered('Status')}\" >Status<i class='fa fa-filter' ng-if='ProcessInstancesCtrl.isFiltered(\"Status\")' ></i></span>"
                }
            ];

            ProcessInstances.columns = angular.copy(ProcessInstances.gridColumn);
            ProcessInstances.schema = {
                UserId: {
                    duplicate: false,
                    unique: false
                },
                UserCode: {
                    duplicate: true,
                    unique: true
                }
            };
    
            return ProcessInstances;
        }]);
})();
